import React from 'react'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import ContactUs from '../components/contact/ContactUs'

const ContactPage = () => {
  return (
    <>
    <Header/>
    <ContactUs/>
    <Footer/>
    </>
  )
}

export default ContactPage